module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"public":"Public","private":"Private","shared":"Shared"},"es":{"public":"Publico","private":"Privado","shared":"NT-Shared-NT"}}')
  delete Component.options._Ctor
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@kazupon/vue-i18n-loader/lib!./src/i18n/access.i18n.json
// module id = XTbL
// module chunks = 1